/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { LinkBanner as LinkBannerModel } from 'models';
import { Row, Column } from 'hedron';
import Container from 'blocks/Container/Container';
import Link from 'blocks/StyledLink';
import styled from 'styled-components';
import ds from 'designsystem';
import Fade from 'react-reveal/Fade';
import { FADE_VALUES, parallaxImage, scaleImage } from 'animations/Animations';
import { Bind } from 'lodash-decorators';
import HTMLModifiableBackground from 'blocks/HTMLModifableBackground/HTMLModifiableBackground';
import Button from 'elements/Button';
import { safeHtmlWithBr } from 'common/methods/string';
import Description from './Description';
import Image from './Image';
import Header from './Header';
import BackgroundImage from './BackgroundImage';
import MobileImagesWrapper from './MobileImagesWrapper';
import DesktopImagesWrapper from './DesktopImagesWrapper';

const StyledContainer = styled(Container)`
  margin-top: ${ds.get('metrics.base')};
  margin-bottom: 0;
`;

const StyledColumn = styled(Column)`
  padding: 0;
  display: flex;
  justify-content: space-between;
  align-self: start;
`;

const StyledRow = styled(Row)`
  align-items: center;
`;

const LinkButton = styled(Button)`
  margin-left: ${ds.get('metrics.s')};
  margin-top: 15px;
`;

const TextWrapper = styled.div`
  width: 100%;
`;

const HideContentContainer = styled.div`
  overflow: hidden;
`;

@inject('windowStore')
@observer
export default class LinkBannerBlock extends Component {
  static propTypes = {
    data: PropTypes.instanceOf(LinkBannerModel).isRequired,
  };

  constructor(props) {
    super(props);
    this.elementRef = React.createRef();
  }

  componentDidMount() {
    const { windowStore } = this.props;
    this.disposeOnScroll = windowStore.reactToScroll(this.onScroll);
    this.onScroll();
  }

  componentWillUnmount() {
    this.disposeOnScroll();
  }

  @Bind
  onScroll() {
    if (this.elementRef.current) {
      scaleImage(this.elementRef.current, 1.1, 0.9);
      parallaxImage(this.elementRef.current, 150, 0, 10);
    }
  }

  render() {
    const {
      data: {
        htmlModifiers,
        description,
        header,
        image,
        backgroundImage,
        slug,
        linkText,
        mobileBackgroundImage,
      },
      windowStore,
    } = this.props;

    return (
      <HTMLModifiableBackground
        htmlModifiers={htmlModifiers}
        color={ds.brand('background')}
      >
        <HideContentContainer>
          <StyledContainer>
            <StyledRow>
              <StyledColumn
                lg={6}
              >
                <Fade
                  distance={`${FADE_VALUES.TEXT.SMALL}`}
                  delay={FADE_VALUES.DELAY.SMALL}
                  bottom
                >
                  <TextWrapper>
                    <Header
                      dangerouslySetInnerHTML={{
                        __html: safeHtmlWithBr(header),
                      }}
                    />

                    {windowStore.isOnTablet ? (
                      <MobileImagesWrapper>
                        <BackgroundImage
                          src={windowStore.adjustImageSize(mobileBackgroundImage || backgroundImage)}
                        />
                        {image && (
                          <Image
                            innerRef={this.elementRef}
                            src={windowStore.adjustImageSize(image)}
                          />
                        )}
                      </MobileImagesWrapper>
                    ) : ''}

                    <Description dangerouslySetInnerHTML={{
                      __html: description,
                    }}
                    />
                    {slug && linkText && (
                      <Link to={slug}>
                        <LinkButton
                          dangerouslySetInnerHTML={{
                            __html: safeHtmlWithBr(linkText),
                          }}
                        />
                      </Link>
                    )}
                  </TextWrapper>
                </Fade>
              </StyledColumn>

              <StyledColumn
                lg={6}
              >
                {windowStore.isOnTablet ? '' : (
                  <React.Fragment>

                    {image && (
                      <DesktopImagesWrapper>
                        <Image
                          innerRef={this.elementRef}
                          src={windowStore.adjustImageSize(image)}
                        />
                      </DesktopImagesWrapper>
                    )}

                    <BackgroundImage
                      src={windowStore.adjustImageSize(backgroundImage)}
                    />

                  </React.Fragment>
                )}
              </StyledColumn>
            </StyledRow>
          </StyledContainer>
        </HideContentContainer>
      </HTMLModifiableBackground>
    );
  }
}



// WEBPACK FOOTER //
// ./src/kentico-blocks/LinkBanner/index.jsx